module.exports = __webpack_public_path__ + "static/img/paleta_raster.0211f872.png";